import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IFilterInput } from 'src/app/interfaces/filtro/IFilterInput';
import { IToken } from 'src/app/interfaces/token/IToken';

@Component({
  selector: 'app-filtro-generico',
  templateUrl: './filtro-generico.component.html',
  styleUrls: ['./filtro-generico.component.scss']
})
export class FiltroGenericoComponent {
  @Output() filterData: EventEmitter<void> = new EventEmitter<void>();
  @Input() filterInputs: IFilterInput[] = [];
  showDisplayPopUp: boolean = false;
  @Input() showOptions: boolean = true;
  filtraForm!: FormGroup;
  @Input() PermissoesUsuario!: IToken | undefined;
  @Output() OnClickApplyButton: EventEmitter<void> = new EventEmitter<void>();
  @Input() filterInputsLista: { label: string; formControlName: string }[] = [];
  @Input() selectInputs: {
    label: string;
    formControlName: string;
    options: any[];
    exibir?: (v: any) => string;
    valor?: (v: any) => any;
  }[] = [];
  @Output() valorSelecionado: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fb: FormBuilder) {}

  showOrhideFilterPopUp() {
    this.showDisplayPopUp = !this.showDisplayPopUp;
  }
  hidePopUp() {
    this.showDisplayPopUp = false;
  }
  showPopUp() {
    this.showDisplayPopUp = true;
  }

  emitFilterData() {
    const filterData = {
      ...this.filtraForm.getRawValue()
    };
    this.filterData.emit(filterData);
  }

  ngOnInit() {
    this.filtraForm = this.fb.group({});
    this.filterInputs.forEach((input) => {
      this.filtraForm.addControl(input.formControlName, this.fb.control(''));
    });
    this.selectInputs.forEach((input) => {
      this.filtraForm.addControl(input.formControlName, this.fb.control(''));
    });
  }
  public getFilterData() {
    return this.filtraForm.getRawValue();
  }
}
